import { useEffect, useRef } from "react";

// Renders the pixel-perfect Tally auth screens (login/signup/forgot/reset) at
// clean routes through React. A same-origin, full-viewport iframe loads
// /auth.html#<view> so its brand CSS is fully isolated from the app's Tailwind
// base styles, and its vanilla JS wires the flows to the backend and stores the
// JWT (tally_token), then navigates the top window on success.
export const AuthFrame = ({ view }) => {
  const ref = useRef(null);
  const search = typeof window !== "undefined" ? window.location.search : "";
  const src = `/auth.html${search}#${view}`;

  useEffect(() => {
    const iframe = ref.current;
    if (!iframe) return;
    const wireLinks = () => {
      const doc = iframe.contentDocument;
      if (!doc) return;
      doc.querySelectorAll("a[href]").forEach((a) => {
        if (a.dataset.wired) return;
        a.dataset.wired = "1";
        const href = a.getAttribute("href");
        if (!href || href.startsWith("#")) return;
        if (href.startsWith("/")) {
          a.addEventListener("click", (e) => { e.preventDefault(); window.location.assign(href); });
        } else if (/^https?:\/\//.test(href)) {
          a.setAttribute("target", "_top");
        }
      });
    };
    iframe.addEventListener("load", wireLinks);
    if (iframe.contentDocument && iframe.contentDocument.readyState === "complete") wireLinks();
    return () => iframe.removeEventListener("load", wireLinks);
  }, []);

  return (
    <iframe
      ref={ref}
      title="Tally"
      src={src}
      data-testid={`auth-frame-${view}`}
      style={{ position: "fixed", inset: 0, border: 0, width: "100%", height: "100%", display: "block", background: "#F4EFE4" }}
    />
  );
};
